import { RavenUseOnClickOutside } from '../helper/helper';
import React, { useState } from 'react';
// import './TabLinkComp.css';
// import { RavenUseOnClickOutside } from '../helper/helper';
type childrenProps = {
  label?: string;
  value?: string | number;
  onClick?: (param?: any) => void;
  active?: boolean;
  hide?: boolean;
};
type listProps = {
  label?: string;
  value?: string | number;
  onClick?: (param?: any) => void;
  active?: boolean;
  children?: childrenProps[];
  hide?: boolean;
};
export interface MyComponentProps {
  className?: string;
  list?: listProps[];
  activeColor?: string;
  defaultColor?: string;
  activeBgColor?: string;
  style?: any;
  dropIconColor?: string;
  dropDownClassName?: string;
  hideSelected?: boolean;
  showParentSelected?: boolean;
  children?: React.ReactNode;
}
const RavenTab = ({
  activeBgColor,
  activeColor,
  className,
  defaultColor,
  list,
  style,
  dropIconColor,
  dropDownClassName,
  hideSelected,
  showParentSelected,
  children,
}: MyComponentProps) => {
  const activeBgColorVal = activeBgColor || 'rgba(1, 67, 69, 0.1)';
  const activeColorVal = activeColor || '#002856';
  const defaultColorVal = defaultColor || '#020202';
  const iconColorVal = dropIconColor || activeColorVal;
  const [dropDownVal, setDropDownVal] = useState<string>('');
  const dropIcon = (param?: string) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        fill="none"
        viewBox="0 0 24 25"
        className="img"
      >
        <path
          stroke={param || '#000'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="m6 9.5 6 6 6-6"
        ></path>
      </svg>
    );
  };
  const checkActiveChildExist = (
    list?: childrenProps[]
  ): boolean | undefined => {
    if (Number(list?.length) > 0) {
      const val = list?.some((chi) => chi?.active);
      return val;
    }
    return undefined;
  };
  const checkActiveChildExistObj = (
    list?: childrenProps[]
  ): childrenProps | undefined => {
    if (Number(list?.length) > 0) {
      const val = list?.find((chi) => chi?.active);
      return val;
    }
    return undefined;
  };
  const dropRef = RavenUseOnClickOutside(() => {
    setDropDownVal('');
  });
  return (
    <div
      style={
        {
          '--var-bg-color': activeBgColorVal,
          '--var-default-color': defaultColorVal,
          '--var-active-color': activeColorVal,
          ...style,
        } as React.CSSProperties
      }
      className={`raven-reusable-tab-link-wrap-index-parent  border-theme-bottom ${
        className ? className : ''
      }`}
    >
      <div className={` raven-reusable-tab-link-wrap-index `} ref={dropRef}>
        {Number(list?.length) > 0 ? (
          <>
            {list?.map((chi, idx) => {
              if (chi?.hide) {
                return <React.Fragment key={idx}></React.Fragment>;
              }
              if (Number(chi?.children?.length) > 0) {
                return (
                  <div
                    key={idx}
                    className={`item-box-children-wrap`}
                    onClick={(e) => {
                      e.stopPropagation();
                      dropDownVal === chi?.label
                        ? setDropDownVal('')
                        : setDropDownVal(chi?.label as string);
                    }}
                    //   ref={dropRef}
                  >
                    <div
                      className={`item-box ${
                        checkActiveChildExist(chi?.children)
                          ? 'item-box-active'
                          : ''
                      }`}
                    >
                      {showParentSelected ? (
                        <>
                          {' '}
                          <p className="label">
                            {checkActiveChildExist(chi?.children)
                              ? ` ${chi?.label}: ${
                                  checkActiveChildExistObj(chi?.children)?.label
                                }`
                              : chi?.label || ''}
                          </p>
                        </>
                      ) : (
                        <p className="label">
                          {checkActiveChildExist(chi?.children)
                            ? checkActiveChildExistObj(chi?.children)?.label
                            : chi?.label || ''}
                        </p>
                      )}
                      <div
                        className={`icon-wrap ${
                          dropDownVal && dropDownVal === chi?.label
                            ? 'icon-wrap-up'
                            : ''
                        }`}
                      >
                        <figure className="img-box">
                          {dropIcon(
                            checkActiveChildExist(chi?.children)
                              ? iconColorVal
                              : defaultColorVal
                          )}
                        </figure>
                      </div>
                    </div>
                    {/* drop down box  start*/}
                    {dropDownVal && dropDownVal === chi?.label ? (
                      <div
                        className={`drop-down-box-wrap white-base-black-bg ${
                          checkActiveChildExist(chi?.children)
                            ? 'drop-down-box-wrap-active'
                            : ''
                        }  border-theme card-bg ${
                          dropDownClassName ? dropDownClassName : ''
                        }`}
                        style={{
                          zIndex:
                            dropDownVal && dropDownVal === chi?.label ? 5 : 1,
                        }}
                      >
                        {chi?.children?.map((ch, i) => {
                          if (ch?.hide) {
                            return <React.Fragment key={i}></React.Fragment>;
                          }
                          if (ch?.active && hideSelected) {
                            return <React.Fragment key={i}></React.Fragment>;
                          }
                          return (
                            <div
                              key={`${i}`}
                              className={`list-item-box ${
                                ch?.active ? 'list-item-box-active' : ''
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                //   ch?.onClick && ch?.onClick(ch);
                                if (!ch?.active) {
                                  ch?.onClick && ch?.onClick(ch);
                                }
                                dropDownVal && setDropDownVal('');
                              }}
                            >
                              <p className="label">{ch?.label}</p>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      ''
                    )}
                    {/* drop down box  end*/}
                  </div>
                );
              }
              return (
                <div
                  key={idx}
                  className={`item-box ${chi?.active ? 'item-box-active' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!chi?.active) {
                      chi?.onClick && chi?.onClick(chi);
                      dropDownVal && setDropDownVal('');
                    }
                  }}
                >
                  <p className="label">{chi?.label || ''}</p>
                </div>
              );
            })}
          </>
        ) : (
          ''
        )}
      </div>
      {/* Other content */}
      {children ? <div className="other-content">{children}</div> : ''}
    </div>
  );
};
export default RavenTab;